function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -96.88,
  x2: -96.95,
  y1: -0.615,
  y2: -0.579,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00a0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00a1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00beff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00d2ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00e3ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -125.21,
  x2: -125.338,
  y1: -2.688,
  y2: -2.688,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffe000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#ffbd00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff9c00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -75.485,
  x2: -75.558,
  y1: -2.111,
  y2: -2.015,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff3a44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -75.541,
  x2: -75.508,
  y1: -1.211,
  y2: -1.168,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#32a071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.069,
  stopColor: "#2da771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15cf74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06e775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00f076"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "frrPath_943",
  fill: "url(#linear-gradient)",
  d: "M34.071 22.5a4.415 4.415 0 0 0-.871 3.194V77.1a4.057 4.057 0 0 0 1.162 3.194l.29.29L63.4 51.831V51.4z",
  "data-name": "Path 943",
  transform: "translate(-33.2 -21.761)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "frrPath_944",
  fill: "url(#linear-gradient-2)",
  d: "M63.383 55.593L53.8 46.01v-.726l9.583-9.584.29.29L75 42.525c3.194 1.888 3.194 4.937 0 6.679z",
  "data-name": "Path 944",
  transform: "translate(-23.888 -15.794)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "frrPath_945",
  fill: "url(#linear-gradient-3)",
  d: "M72.57 52.329L62.841 42.6 33.8 71.641c1.162 1.162 2.759 1.162 4.937.29l33.833-19.6",
  "data-name": "Path 945",
  transform: "translate(-32.929 -12.674)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "frrPath_946",
  fill: "url(#linear-gradient-4)",
  d: "M72.57 42.042L38.737 22.73c-2.033-1.162-3.775-.871-4.937.29l29.041 28.75 9.729-9.729z",
  "data-name": "Path 946",
  transform: "translate(-32.929 -21.991)"
});

var SvgPlaystoreMultiColor = function SvgPlaystoreMultiColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dwdwdv",
    width: 53.508,
    height: 59.878,
    viewBox: "0 0 53.508 59.878",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlaystoreMultiColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/playstore-multi-color.5f5763ee.svg";
export { ForwardRef as ReactComponent };